import { render, staticRenderFns } from "./addRooms.vue?vue&type=template&id=c28d5f18&scoped=true&"
import script from "./addRooms.vue?vue&type=script&lang=js&"
export * from "./addRooms.vue?vue&type=script&lang=js&"
import style0 from "./addRooms.vue?vue&type=style&index=0&id=c28d5f18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28d5f18",
  null
  
)

export default component.exports